Hop.defineModule('input-reset', (root) => {
    const $reset = root.querySelector('[data-reset-input]');
    const $fieldToReset = root.querySelector('input[type="text"]');

    if (!$reset) {
        throw new Error('Missing data-reset-input selector');
    }

    init();

    function autoAddResetClass() {
        root.classList.add('reset');
        // why ? Because in case of search field with autosuggestion, we need to override awesomplete size
    }

    function fieldValue() {
        return $fieldToReset.value;
    }

    function resetField() {
        $fieldToReset.value = '';
        toggleIcon();
        $reset.dispatchEvent(new Event('input:reset'));
    }

    function toggleIcon() {
        $reset.classList.toggle('visible', fieldValue().length > 0);
    }

    function init() {
        $reset.addEventListener('click', resetField);
        $fieldToReset.addEventListener('input', toggleIcon);
        // Not especially the right place to listen to autocomplete events as they are defined in webmvc-common
        // But I prefer this than a custom module
        // Triggered in /js/Hop/autocomplete.js
        root.addEventListener('autofill-input', toggleIcon);
        toggleIcon();
        autoAddResetClass();
    }

    return function destroy() {
        $reset.removeEventListener('click', resetField);
        $fieldToReset.removeEventListener('input', toggleIcon);
        root.removeEventListener('autofill-input', toggleIcon);
    };
});
